/* eslint-disable no-underscore-dangle */
import { Plugin, Widget } from 'ckeditor5'

export default class CustomCheckBoxes extends Plugin {
  static get requires() {
    return [Widget]
  }

  init() {
    this._defineConverters()
  }

  _defineConverters() {
    const { conversion } = this.editor

    // UPCAST - Transformations applied when receiving data
    conversion.for('upcast').elementToElement({
      model: (viewElement, { writer: modelWriter }) => {
        const checkedAttr = viewElement.getAttribute('checked')
        const isChecked = checkedAttr ? checkedAttr.length >= 0 : false
        const labelText = (viewElement.nextSibling as any)?.data

        const elementModel = modelWriter.createElement('listItem', {
          style: viewElement?.getAttribute('style') ?? '',
          listType: 'todo',
          listIndent: 0,
          todoListChecked: isChecked,
        })

        modelWriter.insertText(labelText, elementModel)

        return elementModel
      },
      view: {
        name: 'div',
        classes: 'checkable-list-item',
      },
      converterPriority: 'high',
    })
  }
}
